export default function keyMirror(keys, prefix) {
  const result = {};

  keys.forEach((key) => {
    result[key] = `${prefix}_${key}`;
  });

  return result;
}



// WEBPACK FOOTER //
// ./src/services/key_mirror.js